import React, { useState } from 'react'

function ZipcodeField(field) {
  const [moddedValue, setModdedValue] = useState(field.value)

  function handleZipcodeChange(e) {
    if (/[^0-9-]/.test(e.target.value)) {
      return
    }
    if (e.target.value.length === 6 && e.target.value[5] !== '-') {
      e.target.value = `${e.target.value.slice(0, 5)}-${e.target.value[5]}`
    }
    if (e.target.value.length > 10) {
      e.target.value = e.target.value.slice(0, 10)
    }
    setModdedValue(e.target.value)

    if (field.onChange) {
      field.onChange(e)
    }
  }

  return (
    <input
      type="text"
      value={moddedValue}
      name={field.name}
      onChange={e => {
        handleZipcodeChange(e)
      }}
      onBlur={e => field.onBlur(e)}
      className="form__input"
      id="zipcode"
      required
    />
  )
}

export default ZipcodeField
